// 261005 E1-P2 / E5 — đáy thanh trái của chặng ⑤: MỘT dòng "Đọc cả mùa: … · Xem".
// ("n tập cần xem", "n tập đã khớp…" đã có ở chỗ khác; "Đẩy sang Chapters…" là nút chính thanh trên.)
import React from 'react';
import { Button } from 'antd';

interface Props {
  readerText: string;
  /** Có kịch bản DRAFT ⇒ có gì để xem. */
  canViewReader: boolean;
  onOpenReader: () => void;
}

const ScriptFooter: React.FC<Props> = ({ readerText, canViewReader, onOpenReader }) => (
  <div className="wb-sc-footer">
    <span className="wb-sc-footer-t" title={readerText}>{readerText.replace(/^AI đọc cả mùa/, 'Đọc cả mùa')}</span>
    {canViewReader && <Button size="small" type="link" onClick={onOpenReader}>Xem</Button>}
  </div>
);

export default ScriptFooter;
